"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Box_1 = __importDefault(require("@material-ui/core/Box"));
var cancel_1 = __importDefault(require("./cancel"));
var submit_1 = __importDefault(require("./submit"));
var FormButtons = function (props) {
    var cancelLabel = props.cancelLabel, onCancel = props.onCancel, submitLabel = props.submitLabel;
    return (react_1["default"].createElement(Box_1["default"], { display: "flex", alignItems: "center", justifyContent: "flex-end" },
        react_1["default"].createElement(submit_1["default"], { label: submitLabel }),
        onCancel && react_1["default"].createElement(cancel_1["default"], { label: cancelLabel, onClick: onCancel })));
};
exports["default"] = FormButtons;
